// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page_wrapper__1X4Rc","container":"Page_container__1PffN"};